import React, { useEffect } from 'react';
import './live-pop-up.css';
import { generateClient } from 'aws-amplify/api';
import { useParams } from 'react-router';
import * as config from '../../aws-exports';
import { updateMeetingStatus } from '../../graphql/mutations';
import UpdateMeetingStatus from '../../services/event/update-meeting-status';
import { toast } from 'react-toastify';
import disconnectAttendees from '../../services/attendee-login/disconnectAttendees';
import { fetchAttendeeCount } from '../../services/attendee-login/activeCount';
import DeleteMeetingStatusRedis from '../../services/event/delete-meeting-status-redis';
import UpdateMeetingStatusRedis from '../../services/event/update-meeting-status-redis';
const client = generateClient(config);

interface SdkData {
  meetingNumber: string;
  password: string;
  userName: string;
  userEmail: string;
  signature: string;
  tk?: string;
}

interface LivePopupProps {
  sdkData: SdkData;
  setIsPopupVisible: (isVisible: boolean) => void;
  onClose: () => void;
  mStatus: boolean;
}
declare global {
  var webinarEndInterval: NodeJS.Timeout | null;
}
if (typeof globalThis.webinarEndInterval === "undefined") {
  globalThis.webinarEndInterval = null;
}
 const callGraphqlUpdateMeetingStatus = async (
    webinarStatus: boolean,
    numericEventId: number
  ) => {
    const variables = {
      eventid: numericEventId.toString(),
      meetingstatusflag: webinarStatus,
    };
    try {
      await client.graphql({
        query: updateMeetingStatus,
        variables: variables,
      });
    } catch (error) {
      console.error("Error updating meeting status:", error);
      toast.error("Error updating meeting status");
    }
  };

const LivePopup: React.FC<LivePopupProps> = ({ sdkData, setIsPopupVisible, onClose, mStatus }) => {
  const { eventId } = useParams<{ eventId: string }>();
  const webinarStatus = mStatus ? false : true
  const [isLoading, setIsLoading] = React.useState(false);
  const handleYesClick = async () => {
    setIsLoading(true);
    try {
      const numericEventId = Number(eventId);
      if (webinarStatus && globalThis.webinarEndInterval) {
        clearInterval(globalThis.webinarEndInterval);
        globalThis.webinarEndInterval = null;
      }
      // Initialize the payload with isMeetingLive
      const payload: any = {
        isMeetingLive: webinarStatus, // Sending isMeetingLive in the payload
      };
      // Conditionally add isMeetingEnd if isMeetingLive is false
      if (!webinarStatus) {
        payload.isMeetingEnd = true;  
      } else {
        payload.isMeetingEnd = false;
      }

      const response = await UpdateMeetingStatus(payload, numericEventId);

      if (response && response.status === 200) {
        if(webinarStatus){
          const updatePayload: any = {
            webinarId: numericEventId,
            isMeetingLive: webinarStatus, // Sending isMeetingLive in the payload
          };
          await UpdateMeetingStatusRedis(updatePayload);
        }      
        if(!webinarStatus){
          const deletePayload: any = {
            webinarId: numericEventId,
          };
          await DeleteMeetingStatusRedis(deletePayload);
        }
        const variables = {
          eventid: eventId as string,
          meetingstatusflag: webinarStatus,
        };
        try {
          await client.graphql({
            query: updateMeetingStatus,
            variables: variables,
          });
          // Close the popup after successful update
          setIsPopupVisible(false);
          onClose();
          if(!webinarStatus){
          const tempPayload = { webinarId:numericEventId, };
          const res = await disconnectAttendees(tempPayload);
            if(res.status == 201){
            fetchAttendeeCount(numericEventId.toString());
              globalThis.webinarEndInterval = setInterval(() => {
              callGraphqlUpdateMeetingStatus(false, numericEventId);
              }, 15000);
           }
          }
        } catch (error) {
          console.error('Error updating meeting status:', error);
          toast.error('Error updating meeting status');
          setIsLoading(false);
        }

      } else if (response && response.status === 404) {
        toast.error(response.data.message);
        setIsLoading(false);
      } else {
        toast.error('API call failed');
        setIsLoading(false);
      }
    } catch (error) {
      if (error instanceof Error) {
        toast.error(`Error: ${error.message}`);
      } else {
        toast.error('An unexpected error occurred');
      }
      setIsLoading(false);
    }
  };

  const handleCloseClick = () => {
    setIsPopupVisible(false);
    onClose();
  };

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <div className="text-wrapper">{webinarStatus ? "Go Live" : "End webinar"}</div>
        <div className="option-wrapper">
          <button className="option-btn" onClick={handleYesClick} disabled={isLoading}>
          {isLoading ? 'Loading...' : 'Yes'}
          </button>
          <button className="option-btn" onClick={handleCloseClick} disabled={isLoading}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default LivePopup;
